import React, { FC, ReactNode } from 'react';

import { Navigate } from 'react-router';

import { useFlag } from 'state/launchdarkly';
import { useLocationContext } from 'state/location';
import { useStoreContext } from 'state/store';
import { findStoreNumberInUrl } from 'state/store/hooks';
import { LaunchDarklyFlag } from 'utils/launchdarkly';
import { routes } from 'utils/routing';

// Ensures that a store is selected before rendering children
export const StoreSelected: FC<{ children: ReactNode }> = ({ children }) => {
  const { noStoreSelected } = useStoreContext();
  const { location, setStoreLocatorCallbackUrl } = useLocationContext();
  const enableStaticMenu = useFlag(LaunchDarklyFlag.ENABLE_STATIC_MENU);
  const storeNumberInUrl = findStoreNumberInUrl(location.search);

  // if enableStaticMenu is true, allow menu to be seen with no store selected
  if (noStoreSelected && !enableStaticMenu && !storeNumberInUrl) {
    setStoreLocatorCallbackUrl(`${location.pathname}${location.search}`);
    return <Navigate to={routes.storeLocator} />;
  }

  return <>{children}</>;
};
